module.exports = __webpack_public_path__ + "media/images/pic/courses/intensity-standard-ce0c66f1328e9ae9d48cf6801255c53b.svg";